var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.677 4.583a.917.917 0 00-.715.34l-4.427 5.5a.916.916 0 000 1.164l4.583 5.5a.918.918 0 001.412-1.173L9.432 11l3.96-4.913a.917.917 0 00-.715-1.504z",
    fill: "#fff"
  })));
}

export default SvgShevronLeft;